<template>
  <div id="app">
    <top v-if="showTopFooter"></top>
    <router-view v-if="showMain" />
    <foot v-if="showMain && showTopFooter"></foot>
  </div>
</template>

<script>
import top from "./pages/top";
import foot from "./pages/foot";

const slideConfigUri = "website/index/slideshow/conf/detail";
const basicConfigUri = "website/index/basics/detail";
const proBusConfigUri = "website/index/pro/bus/basics/detail";
const dynamicConfigUri = "website/index/news/basics/detail";
const aboutConfigUri = "website/index/us/basics/detail";
const honorConfigUri = "website/index/honor/conf/detail";
const leaderConfigUri = "website/index/leader/conf/detail";
const recruitConfigUri = "website/index/recruit/basics/detail";

export default {
  name: "App",
  components: {
    top,
    foot
  },
  data() {
    return {
      basic: {},
      taskNum: 0,
      showMain: false,
      showTopFooter: false
    };
  },
  created() {
    this.getSlideConfig();
    this.getBasicConfig();
    this.getProBusConfig();
    this.getDynamicConfig();
    this.getAboutConfig();
    this.getHonorConfig();
    this.getLeaderConfig();
    this.getRecruitConfig();
  },
  methods: {
    // 获取轮播图配置
    getSlideConfig() {
      this.taskNum++;
      this.$api.get(slideConfigUri).then(res => {
        res.interval_time = res.interval_time * 1000;
        // console.log(res);
        res.catalog = JSON.parse(res.catalog || "[]");
        this.$cache.set("slideConfig", res);
        this.taskNum--;
        // console.log(
        //   "%cslideConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    },
    // 获取基础配置
    getBasicConfig() {
      this.taskNum++;
      this.$api.get(basicConfigUri).then(res => {
        // res.video = "http://vjs.zencdn.net/v/oceans.mp4";
        this.$cache.set("basicConfig", res);
        this.taskNum--;
        // console.log(
        //   "%cbasicConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    },
    // 获取产品业务配置
    getProBusConfig() {
      this.getProductConfig();
      this.getBusinessConfig();
    },
    // 获取产品配置
    getProductConfig() {
      this.taskNum++;
      this.$api
        .get(proBusConfigUri, {
          pro_bus: 1
        })
        .then(res => {
          res.interval_time = res.interval_time * 1000;
          this.$cache.set("productConfig", res);
          this.taskNum--;
          // console.log(
          //   "%cproductConfig ->",
          //   "background: yellow; color: green; padding: 2px 5px;",
          //   res
          // );
        }).catch(() => { this.taskNum--; });
    },
    // 获取业务配置
    getBusinessConfig() {
      this.taskNum++;
      this.$api
        .get(proBusConfigUri, {
          pro_bus: 2
        })
        .then(res => {
          res.interval_time = res.interval_time * 1000;
          this.$cache.set("businessConfig", res);
          this.taskNum--;
          // console.log(
          //   "%cbusinessConfig ->",
          //   "background: yellow; color: green; padding: 2px 5px;",
          //   res
          // );
        }).catch(() => { this.taskNum--; });
    },
    // 获取新闻动态配置
    getDynamicConfig() {
      this.getInnerDynamicConfig();
      this.getOuterDynamicConfig();
    },
    // 获取内部动态配置
    getInnerDynamicConfig() {
      this.taskNum++;
      this.$api
        .get(dynamicConfigUri, {
          in_out: 1
        })
        .then(res => {
          this.$cache.set("innerDynamicConfig", res);
          this.taskNum--;
          // console.log(
          //   "%cinnerDynamicConfig ->",
          //   "background: yellow; color: green; padding: 2px 5px;",
          //   res
          // );
        }).catch(() => { this.taskNum--; });
    },
    // 获取外部动态配置
    getOuterDynamicConfig() {
      this.taskNum++;
      this.$api
        .get(dynamicConfigUri, {
          in_out: 2
        })
        .then(res => {
          this.$cache.set("outerDynamicConfig", res);
          this.taskNum--;
          // console.log(
          //   "%couterDynamicConfig ->",
          //   "background: yellow; color: green; padding: 2px 5px;",
          //   res
          // );
        }).catch(() => { this.taskNum--; });
    },
    // 获取关于我们基础配置
    getAboutConfig() {
      this.taskNum++;
      this.$api.get(aboutConfigUri).then(res => {
        // res.video = "http://vjs.zencdn.net/v/oceans.mp4";
        this.$cache.set("aboutConfig", res);
        this.taskNum--;
        // console.log(
        //   "%caboutConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    },
    // 获取荣誉配置
    getHonorConfig() {
      this.taskNum++;
      this.$api.get(honorConfigUri).then(res => {
        this.$cache.set("honorConfig", res);
        this.taskNum--;
        // console.log(
        //   "%chonorConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    },
    // 获取领导配置
    getLeaderConfig() {
      this.taskNum++;
      this.$api.get(leaderConfigUri).then(res => {
        res.interval_time = res.interval_time * 1000;
        this.$cache.set("leaderConfig", res);
        this.taskNum--;
        // console.log(
        //   "%cleaderConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    },
    // 获取招贤纳士配置
    getRecruitConfig() {
      this.taskNum++;
      this.$api.get(recruitConfigUri).then(res => {
        res.interval_time = res.interval_time * 1000;
        this.$cache.set("recruitConfig", res);
        this.taskNum--;
        // console.log(
        //   "%crecruitConfig ->",
        //   "background: yellow; color: green; padding: 2px 5px;",
        //   res
        // );
      }).catch(() => { this.taskNum--; });
    }
  },
  watch: {
    taskNum(now, old) {
      this.showMain = !now;
    },
    $route: {
      handler: function (val, oldVal) {
        if (val.path.includes("im")) {
          const other = document.getElementById("cert_show_img");
          other && (other.parentElement.parentElement.style.display = "none");
          this.showTopFooter = false;
        } else {
          this.showTopFooter = true;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style-type: none;
}

#app {
  background: #f2f2f2;

  .web-content {
    min-height: calc(100vh - 268px);
  }
}

.text-center {
  text-align: center;
}
</style>


